<template>
  <div>
    <b-card>
      <b-card-body>
        <b-card-text>SUBSCRIPTION</b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped>

</style>
